import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ru from "./lang/ru.yaml";

const resources = {
  ru,
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "ru",
    lng: "ru",
    keySeparator: ".",
    nsSeparator: ":",
  });

export default i18n;
